import { firebaseConfig } from '@/firebaseConfig.js'
import * as firebase from 'firebase'
require('firebase/firestore')

export const logout = () => {
  return (
    firebase.auth().signOut().then(() => {
      return true
    }).catch(function(error) {
      return error
    })
  )
}

export const getCurrentUser = () => {
  return firebase.auth().currentUser
}

export const getUserData = () => {
  let currentUserId = firebase.auth().currentUser.uid
  let collectionRef = firebase.firestore().collection('users').doc(currentUserId)

  return collectionRef
    .get()
    .then(doc => {
      return doc.data()
    })
    .catch(e => {
      return e
    })
}

export const getDateBySeconds = (date_firebase, plain_format) => {
  let date = new Date(date_firebase.seconds * 1000)
  if (plain_format) {
    return date.toISOString().split('T')[0]
  }
  let month_name = date.toLocaleString('es-es', { month: "long" })
  let day = "0" + date.getDate()
  return day.substr(-2) + ' de ' + month_name + ' ' + date.getFullYear()
}

export const getDateToFirestore = (date) => {
  return firebase.firestore.Timestamp.fromDate(date)
}

export const getDateFromFirestore = (date) => {
  return firebase.firestore.Timestamp.toDate(date)
}

export const getDocById = (collection, id) => {
  return firebase.firestore().collection(collection).doc(id)
}

export const getPlans = () => {
  let collectionRef = firebase.firestore().collection('plans')
  let results = []

  return (
    collectionRef
      .get()
      .then(querySnapshot => {
        querySnapshot.forEach(doc => {
          results.push({
            id: doc.id,
            ...doc.data()
          });
        });
        return results
      })
      .catch(error => {
        return error
      })
  )
}

export const getUsers = () => {
  let collectionRef = firebase.firestore().collection('users')
  let results = []

  return (
    collectionRef
      .get()
      .then(querySnapshot => {
        querySnapshot.forEach(doc => {
          let user_data = doc.data()

          user_data.plan.get().then(plan_result => {
            let plan = plan_result.data()
            plan.id = plan_result.id
            user_data.plan = plan

            results.push({
              id: doc.id,
              ...user_data
            });
          })
        })
        return results
      })
      .catch(error => {
        return error
      })
  )
}

export const updateUser = user => {
  let collectionRef = firebase.firestore().collection('users').doc(user.id)

  return (
    collectionRef
      .set({
        name: user.name,
        email: user.email,
        plan: user.plan,
        admin: user.admin,
        active: user.active,
        affiliation_date: user.affiliation_date
      })
      .then(() => {
        return true
      })
      .catch(error => {
        throw error
      })
  )
}

export const createUser = user => {
  let secondaryApp = firebase.initializeApp(firebaseConfig, "Secondary")
  return secondaryApp
    .auth()
    .createUserWithEmailAndPassword(user.email, user.password)
    .then(newUser => {
      user.id = newUser.user.uid
      return updateUser(user)
      .then(() => {
        secondaryApp
          .auth()
          .signOut()
          .then(() => {
            secondaryApp.delete()
          })
        return true
      })
      .catch(error => {
        secondaryApp
          .auth()
          .signOut()
          .then(() => {
            secondaryApp.delete()
          })
        throw error
      })
    })
    .catch(error => {
      secondaryApp.delete()
      throw error
    })
}

export const toggleActiveUser = (user) => {
  return firebase
    .firestore()
    .collection("users")
    .doc(user.id)
    .update({
      active: !user.active
    })
    .then(() => {
      return true
    })
    .catch(error => {
      throw error
    });
}
